/* global $, Modernizr */

import throttle from '../helpers/throttle';

const $window = $(window);
const $header = $('.js-header');
const $navigation = $('.js-navigation');
const DROPDOWN_TOGGLER_SELECTOR = '.js-dropdown-toggler';
const DROPDOWN_ITEM_SELECTOR = '.navigation-dropdown__item';

const BREAKPOINT = 991;

const isMobileNavigation = () => Modernizr.mq(`(max-width: ${BREAKPOINT}px)`);
const isTouchDevice = () => Modernizr.touchevents;

const navigation = {
  initialize() {
    if ($navigation.length) {
      this.createEvents();
    }
  },

  createEvents() {
    const throttledScroll = throttle(this.scroll.bind(this), 40);

    if (isMobileNavigation() || isTouchDevice()) {
      $(DROPDOWN_TOGGLER_SELECTOR).on('click', (e) => {
        const $target = $(e.currentTarget);
        const $dropdown = $target.next();
        const isOpen = $dropdown.hasClass('is-open');

        e.preventDefault();

        $target.parent().attr('aria-expanded', !isOpen);

        this.hideDropdowns($dropdown);
        this.toggleDropdown($dropdown, isOpen);
      });
    }

    $window.on('scroll', () => {
      throttledScroll();
    });
  },

  toggleDropdown($dropdown, isOpen) {
    const items = $dropdown.find(`${DROPDOWN_ITEM_SELECTOR}:visible`);
    const height = this.calculateDropdownHeight(items);

    $dropdown.toggleClass('is-open');

    if (isMobileNavigation()) {
      $dropdown.css('height', isOpen ? 0 : height);
    }
  },

  hideDropdowns($dropdown) {
    $navigation
      .find('.js-dropdown.is-open')
      .not($dropdown)
      .removeClass('is-open')
      .css('height', 0)
      .parent()
      .attr('aria-expanded', false);
  },

  calculateDropdownHeight(items) {
    return items.toArray().reduce((accumulator, item) => (
      accumulator + $(item).outerHeight()
    ), 0);
  },

  scroll() {
    const top = $window.scrollTop();

    if (top > $header.height() && !$navigation.hasClass('is-sticky')) {
      $navigation.addClass('is-sticky');
    } else if (top <= $header.height() && $navigation.hasClass('is-sticky')) {
      $navigation.removeClass('is-sticky');
    }
  },
};

export default navigation;
